/**
 * Remove string without its accents
 * @param {string} str
 * @returns {string}
 */

export function removeAccent(str) {
    const replaceDictionary = {
        Á: 'A',
        À: 'A',
        Â: 'A',
        Ä: 'ae',
        Ã: 'A',
        Å: 'A',
        Ç: 'C',
        É: 'E',
        È: 'E',
        Ê: 'E',
        Ë: 'E',
        Í: 'I',
        Ï: 'I',
        Î: 'I',
        Ì: 'I',
        Ñ: 'N',
        Ó: 'O',
        Ò: 'O',
        Ô: 'O',
        Ö: 'oe',
        Õ: 'O',
        Ú: 'U',
        Ù: 'U',
        Û: 'U',
        Ü: 'ue',
        Ý: 'Y',
        á: 'a',
        à: 'a',
        â: 'a',
        ä: 'ae',
        ã: 'a',
        å: 'a',
        ç: 'c',
        é: 'e',
        è: 'e',
        ê: 'e',
        ë: 'e',
        í: 'i',
        ì: 'i',
        î: 'i',
        ï: 'i',
        ñ: 'n',
        ó: 'o',
        ò: 'o',
        ô: 'o',
        ö: 'oe',
        õ: 'o',
        ú: 'u',
        ù: 'u',
        û: 'u',
        ü: 'ue',
        ý: 'y',
        ÿ: 'y',
        œ: 'oe',
        Œ: 'Oe',
        ß: 'ss',
    };
    return str
        .split('')
        .map(char => (replaceDictionary[char] ? replaceDictionary[char] : char))
        .join('');
}

/**
 * Generate slug from input string and id
 * @param {string} str
 * @param {number} id
 * @returns {string}
 */
export function categorySlugifier(str, id) {
    if (!str || !id) {
        return '';
    }
    const res = removeAccent(str.toLowerCase())
        .replace(/[\d_]+/g, ' ')
        .trim()
        .replace(/\s+/g, '-');
    if (res.length === 0) return '-';

    return `${res}-${id}`;
}
